// CRM 2.0 page access (M1-F9). The "CRM 2.0" permission key also carries other
// rights (e.g. Legal's Settings › Customer Consent), so the CRM 2.0 menu and page
// need CRM 2.0 › "Tabs and sub-tabs" (prototype A4), or Super Admin.
export function canOpenCrm2(user) {
  const tabs = user?.roleId?.accessibleTabs?.["CRM 2.0"];
  return user?.roleId?.level == 1 || !!(tabs?.isAccessible && tabs?.["Tabs and sub-tabs"]?.isAccessible);
}
